<template>
    <ul>
        <li><p>{{items.name}}</p></li>
        <li v-for="(item, name, index) in items.questions">
            <div class="score" @click="getQuestion(item.pivot.id)" v-bind:class="[{ correct: (item.pivot.solved!=0)},'n'+item.pivot.attemps, {n6:(item.pivot.attemps > 5)}]">{{item.id}}</div></li><li v-for="n in (17 - items.questions.length)">
            <div class="score n0 " >
                {{ (n + parseInt(items.questions.length) ) }}
            </div>
        </li><li v-if="items.questions.length == 17 && items.questions[16].pivot.solved !=0 "><i class="fas fa-check color-green" @click="setUserReady(items)"></i></li>
        <div class="popup" v-show="question" v-click-outside="closePopUp">
            <h3>Vraag: {{question}}</h3>
            <h3> Antwoord: {{answer}}</h3>
            <h3> Pogingen: {{attemps}}<i v-bind:class="{ 'fas fa-check color-green': solved == '1', 'fas  fa-times color-red' : (solved == '0')}"></i></h3>
            <button @click="closePopUp">Sluit</button>
        </div>
    </ul>
</template>

<script>
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });
    Vue.use(VueAxios, axios)
    export default {
        name: "ScoreBarComponent",
        props: ['items'],
        data(){
            return {
                question:null,
                answer:null,
                attemps:null,
                solved : null
            }
        },
        methods: {
            getQuestion(questionid){
                const AuthStr = 'Bearer '+localStorage.getItem('user-token');
                axios.get('/api/questions/'+questionid, { headers: { Authorization: AuthStr } }).then(resp => {
                this.question = resp.data.question
                this.answer = resp.data.answer
                this.attemps = resp.data.attemps;
                this.solved = resp.data.solved;
            })
            },
            setUserReady(user){
                const AuthStr = 'Bearer '+localStorage.getItem('user-token');
                axios.get('/api/users/'+user.id, { headers: { Authorization: AuthStr } }).then(resp => {
                    this.items.ready = true;
                })

            },
            closePopUp(){
                this.question = null
                this.answer = null
            }
        }
    }
</script>

<style scoped>
    ul{
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    li  {
        display: inline;
        color: white;
        text-align: center;
        padding: 3px;
        text-decoration: none;
    }
    li > div {
        color:blue;
    }
    .score{
        display: inline-block;
        width: 30px;
        background-color: #f8fafc;
        cursor: pointer;
    }
    .correct{
        background-color: #ca700d;
        color: #f8fafc;
    }
    .n1{
        background-color: #36ca2b;
        color: #f8fafc;
    }
    .n2{
        background-color: #9dca35;
        color: #f8fafc;
    }
    .n3{
        background-color: #b8ca3c;
        color: #f8fafc;
    }
    .n4{
        background-color: #c4ca30;
        color: #f8fafc;
    }
    .n5{
        background-color: #caad22;
        color: #f8fafc;
    }
    .n6{
        background-color: rgba(255, 18, 0, 0.76);
        color: #f8fafc;
    }
    .perfect{
        border: greenyellow;
        box-shadow: 0 5px 15px 0px rgba(5, 202, 28, 0.6);
    }
    .incorrect{
        border: red;
        box-shadow: 0 5px 15px 0px rgba(255, 18, 0, 0.76);
    }
    p{
        display: inline-block;
        width: 160px;
        margin: 2px 0px 2px 0px;
        text-align: left;
    }
    .popup {
        z-index:1000;
        position:absolute;
        background-color: white;
        color: #0c4361;
        width: 60%;
        border: black;
        box-shadow: 0 5px 5px 0px gray;
        padding: 10px;
    }
    button {
        margin-left: 10%;
        margin-right: 10%;
        width: 80%;
        height: 30px;
        font-size: large;
        color:white;
        background-color: #3490dc;
        border: grey;
        box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);

    }

</style>
